import React from 'react';
import ReactDOM from 'react-dom';

import 'AWS-UI-Components-React/index.css';

import App from './App';


ReactDOM.render(
    <App />,
  document.querySelector('#root')
);





// WEBPACK FOOTER //
// ./src/index.js